import React, { FC } from 'react';
import ErrorBox from './ErrorBox';

type Props = {
    height: number | null;
    error: any;
    showIcon?: boolean;
};

//Error component that can be used in table
//usage available in plancomparisoncontainer component
const TableErrorBox: FC<Props> = ({ height, error, showIcon = true }) => {
    return (
        <div
            style={{
                height: !isNaN(Number(height)) ? Number(height) - 68 : 'auto',
            }}
        >
            {showIcon ? (
                <ErrorBox style={{ height: '100%', justifyContent: 'center' }} msg={String(error)} />
            ) : (
                <div className="h-full flex justify-center items-center text-fontGreyAlt">{error}</div>
            )}
        </div>
    );
};

export default TableErrorBox;
